import React from 'react';
import FeaturedItems from '../../../shared/templates/CategoryTemplate/featured-items';
import EventsFeaturedPreview from './EventsFeaturedPreview';

export default function EventsFeatured(props) {
    return (
        <FeaturedItems 
            {...props}
            FeaturedItemPreview={EventsFeaturedPreview}
        />
    );
}